import { Analysis, ProbabilityCategory, PanelMarker, 
    PossibleRootCauseCategory } from '.';

export class WBCAnalysis extends Analysis {
    immuneSystemDisorderProbability?: number;
    immuneSystemDisorderProbabilityCategory?: ProbabilityCategory;

    reset() {
        super.reset()
        this.immuneSystemDisorderProbability = -1;
        this.immuneSystemDisorderProbabilityCategory = ProbabilityCategory.NA;
    }

    performAnalysis() {
        super.performAnalysis()
        this.calculateImmuneSystemDisorderProbability();
        this.calculateImmuneSystemDisorderProbabilityCategory();
        // TODO: Add this back in when ready for possible root cause categories are needed for WBC
        // this.calculateInfectionLikelyhood();
    }

    calculateImmuneSystemDisorderProbability?() {
        // 99%
        if (this.ba.wbc.isNotLab()) {
            this.immuneSystemDisorderProbability = 99;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11099);
            return;
        }
        // 95%  
        if (this.ba.wbc.isGreaterThanAvgMaxOrLessThanAvgMin() && this.isNotLab(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 95;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11095);
            return;
        }
        // 93%
        if (this.ba.wbc.isGreaterThanAvgMaxOrLessThanAvgMin() && this.isGreaterThanAvgMaxOrLessThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 93;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11093);
        }

        // 91%							
        if (this.ba.wbc.isGreaterThanAvgMaxOrLessThanAvgMin() && this.isLessThanAvgMaxOrGreaterThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 91;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11091);
            return;
        }

        // 90%
        if (this.ba.wbc.isGreaterThanAvgMaxOrLessThanAvgMin() && this.isBlank(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 90;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11090);
            return;
        }
        // 88%
        if (this.ba.wbc.isLessThanAvgMaxOrGreaterThanAvgMin() && this.isNotLab(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 88;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11088);
            return;
        }
        // 86%
        if (this.ba.wbc.isLessThanAvgMaxOrGreaterThanAvgMin() && this.isGreaterThanAvgMaxOrLessThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 86;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11086);
            return;
        }
        // 84%
        if (this.ba.wbc.isLessThanAvgMaxOrGreaterThanAvgMin() && this.isLessThanAvgMaxOrGreaterThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 84;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11084);
            return;
        }
        // 82%
        if (this.ba.wbc.isLessThanAvgMaxOrGreaterThanAvgMin() && this.isBlank(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 82;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11082);
            return;
        }
        // 80%
        if (this.ba.wbc.isOptimal() && this.isNotLab(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 80;
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11080);
            return;
        }
        // 69%
        if (this.ba.wbc.isOptimal() && this.isGreaterThanAvgMaxOrLessThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 69; // Change after the category was set.
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11078);
            return;
        }
        // 69%
        if (this.ba.wbc.isOptimal() && this.isLessThanAvgMaxOrGreaterThanAvgMin(this.getWBCDifferentialMarkers())) {
            this.immuneSystemDisorderProbability = 69; // Change after the category was set.
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11075);
            return;
        }
       
        if (this.ba.wbc.isOptimal() && this.isBlankOrIsOptimal(this.getWBCDifferentialMarkers())) {
            if (this.ba.globulin.isNotLab()) {
                 // 68%
                if (this.ba.alp.isLessThanLab()) {
                    this.immuneSystemDisorderProbability = 68; // Change after the category was set.
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11070);
                    return;
                }
                // 67%
                if (this.ba.alp.isLessThanOptimal()) {
                    this.immuneSystemDisorderProbability = 67; // Change after the category was set.
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11068);
                    return;
                }
                // 65%
                if (this.ba.alp.isGreaterThanOrIsOptimal() || this.ba.alp.isGreaterThanLab()) {
                    this.immuneSystemDisorderProbability = 65;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11065);
                    return;
                }
            }
            if (this.ba.globulin.isNotOptimal()) {
                // 63%
                if (this.ba.alp.isLessThanLab()) {
                    this.immuneSystemDisorderProbability = 63;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11063);
                    return;
                }
                // 60%
                if (this.ba.alp.isLessThanOptimal()) {
                    this.immuneSystemDisorderProbability = 60;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11060);
                    return;
                }
                // 57%
                if (this.ba.alp.isGreaterThanOrIsOptimal() || this.ba.alp.isGreaterThanLab()) {
                    this.immuneSystemDisorderProbability = 57;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11057);
                    return;
                }
            }
            if (this.ba.globulin.isBlank() || this.ba.globulin.isOptimal()) {
                // 55%
                if (this.ba.alp.isLessThanLab()) {
                    this.immuneSystemDisorderProbability = 55;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11055);
                    return;
                }

                // 50%
                if (this.ba.alp.isLessThanOptimal()) {
                    this.immuneSystemDisorderProbability = 50;
                    this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11050);
                    return;
                }
            }
            // 10%
            // BLANK OR >= Opt OR > Lab
            if ( (this.ba.globulin.isBlank() || this.ba.globulin.isOptimal()) && 
                 (this.ba.alp.isBlank() || this.ba.alp.isGreaterThanOrIsOptimal() || this.ba.alp.isGreaterThanLab())) {
                this.immuneSystemDisorderProbability = 10;
                this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_11010);
                return; 
            }
        }
    }

    calculateImmuneSystemDisorderProbabilityCategory?() {
        if (this.immuneSystemDisorderProbability >= 90) { // 90 - 100
            this.immuneSystemDisorderProbabilityCategory = ProbabilityCategory.HIGHLY_LIKELY;
        } else if (this.immuneSystemDisorderProbability >= 70) { // 70 - 89
            this.immuneSystemDisorderProbabilityCategory = ProbabilityCategory.LIKELY; 
        } else if (this.immuneSystemDisorderProbability >= 50) { // 50 - 69
            this.immuneSystemDisorderProbabilityCategory = ProbabilityCategory.POSSIBLE; 
        } else if (this.immuneSystemDisorderProbability >= 0) { // 0 - 49
            this.immuneSystemDisorderProbabilityCategory = ProbabilityCategory.LESS_LIKELY; 
        }
    }

    calculateInfectionLikelyhood?() {
        if (this.ba.wbc.isGreaterThanLab()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12000);
        } else if (this.ba.wbc.isGreaterThanAvgMax()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12005);
        } else if (this.ba.wbc.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12010);
        } else if (this.ba.wbc.isLessThanLab()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12015);
        } else if (this.ba.wbc.isLessThanAvgMin()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12020);        
        } else if (this.ba.wbc.isGreaterThanAvgMax()) {
        } else if (this.ba.wbc.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_12025);
        }
    }

    isOptimal?(panelMarkers: PanelMarker[]): boolean {
        return panelMarkers.every((pm) => {
         return pm.isOptimal();
        });
     }
    
    isNotLab?(panelMarkers: PanelMarker[]): boolean {
       return panelMarkers.some((pm) => {
        return pm.isNotLab();
       });
    }

    isBlank?(panelMarkers: PanelMarker[]): boolean {
        return panelMarkers.some((pm) => {
         return pm.isBlank();
        });
     }

     isBlankOrIsOptimal?(panelMarkers: PanelMarker[]): boolean {
        return panelMarkers.every((pm) => {
         return pm.isBlank() || pm.isOptimal();
        });
     }

    isGreaterThanAvgMaxOrLessThanAvgMin?(panelMarkers: PanelMarker[]): boolean {
        return panelMarkers.some((pm) => {
            return pm.hasValue() && pm.isGreaterThanAvgMaxOrLessThanAvgMin();
        });
    }

    isLessThanAvgMaxOrGreaterThanAvgMin?(panelMarkers: PanelMarker[]): boolean {
        return panelMarkers.some((pm) => {
            return pm.hasValue() && pm.isLessThanAvgMaxOrGreaterThanAvgMin();
        });
    }

    getWBCDifferentialMarkers?(): PanelMarker[] {
        return [
            this.ba.neutrophilsAbs, this.ba.lymphocytesAbs, this.ba.monocytesAbs, this.ba.eosinophilsAbs, this.ba.basophilsAbs,
            this.ba.neutrophils, this.ba.lymphocytes, this.ba.monocytes, this.ba.eosinophils, this.ba.basophils];
    }

    private addPossibleRootCauseCategory(category: PossibleRootCauseCategory) {
        if (!this.possibleRootCauseCategories.includes(category)) {
            this.possibleRootCauseCategories.push(category);
        }
    }

    private markerHasValue(marker?: PanelMarker): boolean {
        return !!marker && !!marker.hasValue && marker.hasValue();
    }

    private isMarkerHigh(marker?: PanelMarker): boolean {
        if (!this.markerHasValue(marker)) {
            return false;
        }

        return marker.isGreaterThanLab?.() || marker.isGreaterThanOptimal?.() || false;
    }

    private isMarkerLow(marker?: PanelMarker): boolean {
        if (!this.markerHasValue(marker)) {
            return false;
        }

        return marker.isLessThanLab?.() || marker.isStricklyLessThanOptimal?.() || marker.isLessThanOptimal?.() || false;
    }

    private isAnyMarkerHigh(markers: PanelMarker[]): boolean {
        return markers.some((marker) => this.isMarkerHigh(marker));
    }

    private isAnyMarkerLow(markers: PanelMarker[]): boolean {
        return markers.some((marker) => this.isMarkerLow(marker));
    }

    calculateInsights() {
        const wbc = this.ba.wbc;
        const nlr = this.ba.nlr;

        const wbcHigh = this.isMarkerHigh(wbc);
        const wbcLow = this.isMarkerLow(wbc);
        const wbcOptimal = wbc.isOptimal?.() || false;

        const hasNlr = this.markerHasValue(nlr);
        const nlrHigh = this.isMarkerHigh(nlr);
        const nlrLow = this.isMarkerLow(nlr);

        // --- Immune System Pattern Insights: 70001–70009 ---
        // These patterns are driven by WBC status and NLR direction.
        if (hasNlr && wbcHigh && nlrHigh) {
            // Logic: ▲ WBC, ▲ NLR
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70004);
        } else if (hasNlr && wbcHigh && nlrLow) {
            // Logic: ▲ WBC, ▼ NLR
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70005);
        } else if (hasNlr && wbcLow && nlrHigh) {
            // Logic: ▼ WBC, ▲ NLR
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70006);
        } else if (hasNlr && wbcLow && nlrLow) {
            // Logic: ▼ WBC, ▼ NLR
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70007);
        } else if (wbcOptimal && nlrHigh) {
            // Logic: WBC optimal, ▲ NLR
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70008);
        } else if (wbcOptimal && nlrLow) {
            // Logic: WBC optimal, ▼ NLR
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70009);
        } else if (wbcHigh) {
            // Logic: ▲ WBC, NLR blank or optimal
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70002);
        } else if (wbcLow) {
            // Logic: ▼ WBC, NLR blank or optimal
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70001);
        }

        if (wbcOptimal && (this.immuneSystemDisorderProbability ?? -1) >= 50) {
            // Logic: WBC = optimal and Immune System Abnormality is >= 50%
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70003);
        }

        const monocytesHigh = this.isAnyMarkerHigh([this.ba.monocytes, this.ba.monocytesAbs]);
        const eosinophilsHigh = this.isAnyMarkerHigh([this.ba.eosinophils, this.ba.eosinophilsAbs]);
        const basophilsHigh = this.isAnyMarkerHigh([this.ba.basophils, this.ba.basophilsAbs]);

        // --- Immune System Pattern Insights: 70010–70016 ---
        // These patterns are driven by high monocytes, eosinophils, and basophils.
        // Percent and absolute markers are both checked so the visible marker name and arrow can render from whichever marker is out of range.
        if (monocytesHigh && eosinophilsHigh && basophilsHigh) {
            // Logic: ▲ Monocytes, ▲ Eosinophils, ▲ Basophils
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70010);
        } else if (monocytesHigh && eosinophilsHigh) {
            // Logic: ▲ Monocytes, ▲ Eosinophils
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70011);
        } else if (eosinophilsHigh && basophilsHigh) {
            // Logic: ▲ Eosinophils, ▲ Basophils
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70012);
        } else if (monocytesHigh && basophilsHigh) {
            // Logic: ▲ Monocytes, ▲ Basophils
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70015);
        } else if (monocytesHigh) {
            // Logic: ▲ Monocytes
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70013);
        } else if (eosinophilsHigh) {
            // Logic: ▲ Eosinophils
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70014);
        } else if (basophilsHigh) {
            // Logic: ▲ Basophils
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_70016);
        }

        // --- Existing single-marker insights ---
        // These are preserved so existing marker-level tabs/categories continue to work.
        if (this.ba.wbc.isGreaterThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11200);
        } else if (this.ba.wbc.isStricklyLessThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11210);
        }

        if (this.ba.neutrophils.isGreaterThanOptimal() || this.ba.neutrophilsAbs.isGreaterThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11220);
        } else if (this.ba.neutrophils.isStricklyLessThanOptimal() || this.ba.neutrophilsAbs.isStricklyLessThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11230);
        }

        if (this.ba.lymphocytes.isGreaterThanOptimal() || this.ba.lymphocytesAbs.isGreaterThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11240);
        } else if (this.ba.lymphocytes.isStricklyLessThanOptimal() || this.ba.lymphocytesAbs.isStricklyLessThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11250);
        }

        if (this.ba.monocytes.isGreaterThanOptimal() || this.ba.monocytesAbs.isGreaterThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11260);
        } else if (this.ba.monocytes.isStricklyLessThanOptimal() || this.ba.monocytesAbs.isStricklyLessThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11270);
        }

        if (this.ba.eosinophils.isGreaterThanOptimal() || this.ba.eosinophilsAbs.isGreaterThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11280);
        } else if (this.ba.eosinophils.isStricklyLessThanOptimal() || this.ba.eosinophilsAbs.isStricklyLessThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11290);
        }

        if (this.ba.basophils.isGreaterThanOptimal() || this.ba.basophilsAbs.isGreaterThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11300);
        } else if (this.ba.basophils.isStricklyLessThanOptimal() || this.ba.basophilsAbs.isStricklyLessThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11310);
        }

        if (this.ba.nlr.isGreaterThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11320);
        } else if (this.ba.nlr.isStricklyLessThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11330);
        }

        if (this.ba.globulin.isGreaterThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11340);
        } else if (this.ba.globulin.isStricklyLessThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11360);
        }

        if (this.ba.alp.isStricklyLessThanOptimal()) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11370);
        }

        // Zinc as a direct immune signal — low zinc surfaces Immune-section root
        // causes. RBC and serum are handled separately (11375 / 11380), each
        // checking both unit variants. Distinct from CATEGORY_952 (the ALP /
        // stomach-acid proxy in BloodworkAnalysis), which stays as-is.
        const rbcZincMarkers = [this.ba.zincRBCmgL, this.ba.zincRBCμgdL].filter(Boolean);
        if (rbcZincMarkers.some(m => m.hasValue() && m.isStricklyLessThanOptimal())) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11375);
        }

        const serumZincMarkers = [this.ba.zincSerummcgmL, this.ba.zincSerumμgdL].filter(Boolean);
        if (serumZincMarkers.some(m => m.hasValue() && m.isStricklyLessThanOptimal())) {
            this.addPossibleRootCauseCategory(PossibleRootCauseCategory.CATEGORY_11380);
        }
    }
}